import { Component, Input } from '@angular/core';
import { inrDTO } from "../../../../shared/models/inrDTO";

@Component({
  selector: 'app-inr-patient-results',
  templateUrl: './inr-patient-results.component.html',
  styleUrls: ['./inr-patient-results.component.css']
})
export class InrPatientResultsComponent {
  @Input() inr!: inrDTO;
}
